import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numberFormat',
    standalone: false
})
export class NumberFormatPipe implements PipeTransform {

    transform(value: number | string): string | number {
        return value ? (+value).toLocaleString('en-IN') : value;
    }

}
